"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoAppointmentsNotice = void 0;
var _components = require("../../../../components");
var _ = require("../../..");
var _utils = require("../../../../utils");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var NoAppointmentsNotice = function NoAppointmentsNotice(_ref) {
  var onScheduleAppointment = _ref.onScheduleAppointment;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "bg-infoblue-10 p-[16px] pb-[20px] rounded-[6px]"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-sm-medium pb-[16px]"
  }, "This patient has no upcoming appointments."), /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-sm-regular pb-[24px]"
  }, (0, _utils.isTherapist)(user) ? 'Schedule an appointment to maintain their care continuity and track their progress effectively.' : 'Schedule an appointment for a patient check-in and/or to guarantee prompt refill of prescriptions.'), /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    onClick: onScheduleAppointment,
    className: "bg-transparent"
  }, "Schedule appointment"));
};
exports.NoAppointmentsNotice = NoAppointmentsNotice;